import VueTimepicker from 'vue2-timepicker'
import util from '@/util'

export default {
  components: {
    VueTimepicker
  },
  data () {
    return {
      inputValue: null
    }
  },
  props: {
    disabled: Boolean,
    time: [String],
    classField: String
  },
  model: {
    prop: 'time',
    event: 'input'
  },
  mounted () {
    this.inputValue = this.time
  },
  updated () {
    this.inputValue = this.time
  },
  methods: {
    retornarValor (valor) {
      const valorArray = valor.split(':')
      if (valorArray.length !== 2 || !util.stringSoTemNumeros(valorArray[0]) || !util.stringSoTemNumeros(valorArray[1])) {
        valor = ''
      }
      this.$emit('input', valor)
      this.inputValue = valor
    }
  },
  watch: {
    time (valorAtual) {
      if (valorAtual && valorAtual !== 'Invalid Date') {
        this.inputValue = valorAtual
      } else {
        this.inputValue = ''
      }
    }
  },
  render (h) {
    return h(VueTimepicker, {
      class: 'timefieldContainer',
      props: {
        value: this.inputValue,
        format: 'HH:mm',
        inputClass: this.classField,
        disabled: this.disabled,
        placeholder: '--:--',
        manualInput: true,
        hideDropdown: true,
        hideClearButton: true
      },
      on: {
        input: this.retornarValor
      }
    })
  }
}
